import { render, staticRenderFns } from "./FreeAudition.vue?vue&type=template&id=54f1a294&"
import script from "./FreeAudition.vue?vue&type=script&lang=js&"
export * from "./FreeAudition.vue?vue&type=script&lang=js&"
import style0 from "./FreeAudition.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports